import { cn } from '@/lib/utils'

/* The four arms of the mark, in paint order, with their brand fills. Same
   geometry as public/icon.svg (300 × 300 viewBox). */
const ARMS: ReadonlyArray<{ fill: string; d: string }> = [
  {
    fill: '#d03b3c',
    d: 'M230.93,212.63c-4.14,2.81-7.55,4.82-10.57,6.46-26.6,14.36-58.42,18.69-88.68,15.34-30.04-3.19-59.91-12.14-85.82-26.2-7.06-3.94-13.63-8.17-20.22-12.59-2.94-1.61-14.02-9.03-14.02-9.03,0,0,0,43.26-.05,54.42-.02,2.75.4,4.15,2.75,5.95,3.9,2.84,8.8,5.61,13.21,8.03,44.29,23.73,113.56,45.58,163.48,25.92,27.21-11.07,43.02-37.29,40.43-63.87l-.51-4.44Z',
  },
  {
    fill: '#1ead5b',
    d: 'M271.68,44.05C228.37,21.68,165.53,2.17,116.03,16.12c-23.44,6.64-41.01,25.86-46.95,46.86-1.5,5.27-2.74,11.34-2.43,17.25.13,2.52,1.15,9.66,1.48,9.48,0,0,5.71-4.41,7.86-5.93,5.87-4.12,12.34-7.59,19.08-10.14,34.38-12.48,75.44-9.5,110.56-.74,25.32,7.13,48.59,18.51,69.67,32.86,3.35,1.93,13.26,9.66,13.26,9.66,0,0-.09-5.2-.06-6.45.04-10.35.04-39.34,0-49.71.28-8.11-9.83-11.18-16.45-15.03l-.37-.19Z',
  },
  {
    fill: '#f48a2f',
    d: 'M249.06,121.03c-25.99-19.99-59.89-29.03-92.99-33.57-14.85-1.77-32.31-4.12-45.14,4.33-11.76,7.48-14.83,23.39-6,33.7,15.91,17.79,47.19,11.66,69.06,18.74,32.22,8.13,59.84,31.59,65.92,61.72,4.82,22.44-.92,47.55-18.12,64.61-3.15,3.13-4.68,5.52-3.02,5.59,71.69-29.06,92.95-107.41,30.64-154.84l-.35-.27Z',
  },
  {
    fill: '#2c59c3',
    d: 'M88.43,20.9c-.46-1.9-29.7,6.73-47.46,26.38C8.6,83.1,1.45,130.46,35.57,166.11c21.21,22.67,51.28,36.1,82.5,43.12,22.57,4.54,53.36,11.21,73.09-2.55,6.88-5.31,9.5-14.02,6.84-21.98l-.11-.33c-10.17-25.99-49.72-20.45-73.67-28.8-43.74-11.48-75.26-50.76-65.65-91.79,1.62-6.91,4.47-14.16,7.98-19.99,9.42-15.69,17.47-19.28,21.9-22.88Z',
  },
]

interface ScramblMarkProps {
  className?: string
  /** Accessible name; pass an empty string when a sibling carries the label. */
  title?: string
}

/**
 * The full-color Scrambl mark, drawn inline rather than loaded as an image.
 *
 * Flat fills only. A keyline or drop shadow was tried here to lift the mark
 * off same-hue sidebar grounds, and both cost more than they bought: at the
 * 24px render size a hairline stroke is sub-pixel, so it antialiases into a
 * grey smear instead of an edge. Measured on a 24px raster, the share of
 * inked pixels that are partial rather than solid went from 34% (flat fills,
 * level with Google's G at 30%) to 54% with a keyline and shadow. Tone-
 * shifting the fills per ground was the other option and it turns the orange
 * arm muddy. Keep this mark flat; solve contrast with size or placement.
 */
export function ScramblMark({
  className,
  title = 'Scrambl',
}: ScramblMarkProps) {
  return (
    <svg
      viewBox="0 0 300 300"
      className={cn('scrambl-mark', className)}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      {title ? <title>{title}</title> : null}
      {ARMS.map(arm => (
        <path key={arm.fill} d={arm.d} fill={arm.fill} />
      ))}
    </svg>
  )
}
